// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__hYhnW","header":"styles_header__iN4i2","title":"styles_title__soVCG","link":"styles_link__b6c9X","list":"styles_list__0wY82"};
module.exports.__checksum = "520c3cd7d6b0"